export default __webpack_public_path__ + "static/media/IBMPlexSans-ThinItalic-Latin1.bccfbc6d.woff2";